module.exports = __webpack_public_path__ + "img/ci_back_es.112aff64.png";